import { render, staticRenderFns } from "./MyVaultProfileHealth.vue?vue&type=template&id=6bfbe313&scoped=true&"
import script from "./MyVaultProfileHealth.vue?vue&type=script&lang=ts&"
export * from "./MyVaultProfileHealth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfbe313",
  null
  
)

export default component.exports